import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import get from 'lodash/get';
import withProductCustomisation from './withProductCustomisation';
import withQueryParams from './withQueryParams';
import withProducts from './withProducts';
import { skus } from 'src/common/config/product';
import { findProductById } from 'src/common/utils/product';

const withProduct = compose(
  withProducts,
  withProductCustomisation,
  withQueryParams,
  mapProps(({ products, ...props }) => {
    const productId = props.productId || skus[props.productKey] || get(props, 'primary.productId');
    const product = findProductById(products, productId);
    return {
      ...props,
      productId,
      product,
    };
  }),
);

export default withProduct;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withProduct.js